var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0195 10.9133C17.8405 10.9133 19.3165 9.43734 19.3165 7.61634C19.3165 5.79634 17.8405 4.31934 16.0195 4.31934",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5361 14.4963C18.0801 14.5333 18.6201 14.6113 19.1531 14.7293C19.8921 14.8763 20.7821 15.1793 21.0981 15.8423C21.3001 16.2673 21.3001 16.7623 21.0981 17.1873C20.7831 17.8503 19.8921 18.1533 19.1531 18.3053",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.591 15.2063C13.281 15.2063 16.433 15.7653 16.433 17.9983C16.433 20.2323 13.301 20.8103 9.591 20.8103C5.901 20.8103 2.75 20.2523 2.75 18.0183C2.75 15.7843 5.881 15.2063 9.591 15.2063Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.59103 12.0188C7.15703 12.0188 5.20703 10.0678 5.20703 7.63376C5.20703 5.20076 7.15703 3.24976 9.59103 3.24976C12.025 3.24976 13.976 5.20076 13.976 7.63376C13.976 10.0678 12.025 12.0188 9.59103 12.0188Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/Accounts.d45f33eeb0c60cb9300d6561aec340cc.svg";
export { ForwardRef as ReactComponent };